module.exports = __webpack_public_path__ + "media/images/emblems/Seon-blason-35a7d070fe20adb2e54f3afd29323d0a.png";